class SiteCommonQuestions extends HTMLElement {
  #controller;
  #questions = [];

  connectedCallback() {
    this.#controller?.abort();
    this.#controller = new AbortController();
    this.#questions = [...this.querySelectorAll('[data-question]')];
    const { signal } = this.#controller;

    // Capture is required because the native details toggle event does not bubble.
    this.addEventListener('toggle', this.#onToggle, { capture: true, signal });
    this.addEventListener('shopify:block:select', this.#onBlockSelect, { signal });
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  #onToggle = (event) => {
    const question = event.target;
    if (!this.#questions.includes(question) || !question.open) return;

    // Preserve single-open behavior in browsers without support for details[name].
    this.#closeOthers(question);
  };

  #onBlockSelect = (event) => {
    const question = this.#questions.find((item) => item.dataset.blockId === event.detail?.blockId);
    if (!question) return;

    this.#closeOthers(question);
    question.open = true;
  };

  #closeOthers(question) {
    this.#questions.forEach((item) => {
      if (item !== question) item.open = false;
    });
  }
}

if (!customElements.get('site-common-questions')) {
  customElements.define('site-common-questions', SiteCommonQuestions);
}
